module.exports = __webpack_public_path__ + "first-page-share.svg?78bf38afa73e1da8956be82bcac2ced8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/first-page-share.svg
// module id = 288
// module chunks = 2